// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { getAuthUser } from 'utils/auth';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const SUPER_ADMIN_ONLY_IDS = ['users', 'marketing-leads', 'admin-applications', 'plans', 'subscriptions'];

export default function Navigation() {
  const isSuperAdmin = Boolean(getAuthUser()?.is_super_admin);

  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group': {
        const visibleItem = isSuperAdmin
          ? item
          : { ...item, children: item.children.filter((child) => !SUPER_ADMIN_ONLY_IDS.includes(child.id)) };
        return <NavGroup key={visibleItem.id} item={visibleItem} />;
      }
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
